// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PendingOrdersList_container__vxKJD {
  padding: 1rem;
  animation: PendingOrdersList_init__UfeqT 0.5s;
}

.PendingOrdersList_header__QaZ4B {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.PendingOrdersList_header__QaZ4B h3 {
  margin: 0;
  font-size: 1.3rem;
  font-weight: 400;
}

.PendingOrdersList_loader__NOZMR {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}

@keyframes PendingOrdersList_init__UfeqT {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/Pages/AgencyOrders/Backoffice/PendingOrdersList/PendingOrdersList.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,6CAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  padding: 1rem;\n  animation: init 0.5s;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.header h3 {\n  margin: 0;\n  font-size: 1.3rem;\n  font-weight: 400;\n}\n\n.loader {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 3rem;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PendingOrdersList_container__vxKJD`,
	"init": `PendingOrdersList_init__UfeqT`,
	"header": `PendingOrdersList_header__QaZ4B`,
	"loader": `PendingOrdersList_loader__NOZMR`
};
export default ___CSS_LOADER_EXPORT___;
